import {
  PG_NAMA_ASET,
  PG_ALAMAT_ASET,
  PG_TANAH_BANGUNAN,
  PG_LUAS_TANAH,
  PG_LUAS_BANGUNAN,
  PG_STATUS_ASET,
  PG_KETERANGAN,
  PG_PERUSAHAAN_ID,
  PG_KOORDINAT,
  PG_LONGITUDE,
  PG_LATITUDE,
  PG_CREATE_BY_ID,
  PG_APPROVED_BY_ID,
  PG_UPDATED_BY_ID,
  PG_REJECTED_BY_ID,
  PG_CREATE_AT,
  PG_APPROVED_AT,
  PG_UPDATED_AT,
  PG_REJECTED_AT,
    
    } from "../../../constants";
    
    const initialState = {};
    
    export default function daftarAsetReducer(state = initialState, action) {
      switch (action.type) {
        case "GET_DATA_TABLE_DAFTAR_ASET":
          return {
            ...state,
            dataTable: action.data,
          };
        case PG_NAMA_ASET:
          return { ...state, namaAset: action.data };
        case PG_ALAMAT_ASET:
          return { ...state, alamat: action.data };
          case PG_TANAH_BANGUNAN:
          return { ...state, tanahBangunan: action.data };
        case PG_LUAS_TANAH:
          return { ...state, luasTanah: action.data };
        case PG_LUAS_BANGUNAN:
          return { ...state, luasBangunan: action.data };
        case PG_STATUS_ASET:
          return { ...state, statusAset: action.data };
        case PG_KETERANGAN:
          return { ...state, keterangan: action.data };
        case PG_PERUSAHAAN_ID:
          return { ...state, perusahaaId: action.data };
        case PG_KOORDINAT:
          return { ...state, koordinat: action.data };
        case PG_LONGITUDE:
          return { ...state, longitude: action.data };
        case PG_LATITUDE:
          return { ...state, latitude: action.data };
        case PG_CREATE_BY_ID:
          return { ...state, createById: action.data };
        case PG_APPROVED_BY_ID:
          return { ...state, approvedById: action.data };
        case PG_UPDATED_BY_ID:
          return { ...state, updateById: action.data };
        case PG_REJECTED_BY_ID:
          return { ...state, rejectedById: action.data };
        case PG_CREATE_AT:
          return { ...state, createAt: action.data };
        case PG_APPROVED_AT:
          return { ...state, approvedAt: action.data };
        case PG_UPDATED_AT:
          return { ...state, updateAt: action.data };
        case PG_REJECTED_AT:
          return { ...state, rejectAt: action.data };
        default:
          return state;
      }
    }
    